import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import firebase from '../../config/firebase.config';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { useParams } from 'react-router-dom';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';
import { Dropdown, borderedSelectStyles } from '@/components/Dropdown';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
// custom  imports
import './taskpage.css';
import { Spinner } from 'reactstrap';
import { Button, buttonVariants } from '@/components/Button';
import { startCase } from 'lodash';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FirebaseImageUploadPlugin } from './UploadPlugin';
import { useHistory } from 'react-router-dom';
import { TaskHistoryButton } from '../../components/TaskHistory';
import { useTeamMemberDetailsForSelect } from '../../hooks/useTeamMemberDetailsForSelect';
import styles from './TaskPage.module.scss';
import { priorityOptions, statusOptions } from './AddUpdateTask.contants';
import { Input } from '@/components/Input';
const AddUpdateTaskPage = () => {
  const database = firebase.firestore();
  const dispatch = useDispatch();
  const history = useHistory();
  const paramsData = useParams();
  const taskId = paramsData.taskId || null;
  const pName = paramsData?.projectName?.split('-').join(' ') || null;
  const user = useSelector((state) => ({
    activeCompany: state.auth?.profile?.activeCompany,
  }));
  const activeUserProfile = useSelector((state) => ({
    companyList: state.auth?.profile?.companyList,
    profile: state?.auth?.profile,
  }));
  const { profile } = activeUserProfile;
  const { activeCompany } = user;

  const [comments, setComments] = useState([]);
  const [showCommentBox, setShowCommentBox] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editedComment, setEditedComment] = useState('');

  const handleEditComment = (commentId, initialComment) => {
    setEditingCommentId(commentId);
    setEditedComment(initialComment);
  };

  const handleCancelEdit = () => {
    setEditingCommentId(null);
    setEditedComment('');
  };

  const handleUpdateComment = async (commentId) => {
    try {
      // Check if the edited comment is empty
      if (editedComment.trim() === '') {
        window.confirm('Comment cannot be empty!');
        console.log('Comment cannot be empty!');
        return;
      }

      await database
        .collection('taskDatabase')
        .doc(taskId)
        .collection('comments')
        .doc(commentId)
        .update({ comment: editedComment });

      setEditingCommentId(null);
      setEditedComment('');

      // Fetch comments again after editing
      fetchCommentsFromFirebase(taskId).then((commentsData) => {
        setComments(commentsData);
      });

      console.log('Comment updated successfully!');
    } catch (error) {
      console.error('Error updating comment:', error);
    }
  };

  const handleDeleteComment = async (commentId) => {
    if (window.confirm('Are you sure you want to delete this comment?')) {
      try {
        await database
          .collection('taskDatabase')
          .doc(taskId)
          .collection('comments')
          .doc(commentId)
          .update({ deleted: true });

        // Fetch comments again after updating
        fetchCommentsFromFirebase(taskId).then((commentsData) => {
          setComments(commentsData);
        });

        console.log('Comment marked as deleted successfully!');
      } catch (error) {
        console.error('Error marking comment as deleted:', error);
      }
    }
  };

  const addCommentToFirebase = async (taskId, timestamp, commentData) => {
    try {
      const commentWithDeleted = { ...commentData, deleted: false };
      await database
        .collection('taskDatabase')
        .doc(taskId)
        .collection('comments')
        .doc(timestamp)
        .set(commentWithDeleted);
      console.log('Comment added successfully to Firebase!');
      return true;
    } catch (error) {
      console.error('Error adding comment to Firebase:', error);
      throw error;
    }
  };
  const fetchCommentsFromFirebase = async (taskId) => {
    try {
      const commentsSnapshot = await database
        .collection('taskDatabase')
        .doc(taskId)
        .collection('comments')
        .where('deleted', '==', false)
        .get();
      const commentsData = commentsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      return commentsData;
    } catch (error) {
      console.error('Error fetching comments from Firebase:', error);
      return [];
    }
  };

  useEffect(() => {
    if (taskId) {
      fetchCommentsFromFirebase(taskId).then((commentsData) => {
        setComments(commentsData);
      });
    }
  }, [taskId]);

  const handleAddComment = () => {
    if (newComment.trim() === '') {
      // Show a message indicating that the comment cannot be empty
      window.confirm('Comment cannot be empty!');
      console.log('Comment cannot be empty!');
      return;
    }
    const timestamp = new Date().getTime().toString();
    const userId = profile?.id;
    // const strippedNewComment = stripHtmlTags(newComment);
    setNewComment('');
    setShowCommentBox(false);
    addCommentToFirebase(taskId, timestamp, {
      userId,
      comment: newComment,
    }).then((result) => {
      if (result) {
        fetchCommentsFromFirebase(taskId).then((commentsData) => {
          setComments(commentsData);
        });
      }
    });
  };

  const [projectId, setProjectId] = useState();
  useEffect(() => {
    console.log('something');
    const fetchProjectId = async () => {
      const projectsRef = database
        .collection('companyDatabase')
        .doc(activeCompany.companyId)
        .collection('projects');
      const querySnapshot = await projectsRef
        .where('project_name', '==', pName)
        .get();
      querySnapshot.forEach((doc) => {
        let newData = doc.data();
        if (newData.deleted === true) return;
        setProjectId(doc.id);
        callTaskList(doc.id);
      });
    };
    fetchProjectId();
  }, [pName]);

  const imageUpload = useSelector((state) => ({
    imageUpload: state.taskImage.isLoading,
  }));

  const teams = useSelector((state) => ({
    teams: state.team.teams,
    loadingProject: state.team.loadingProject,
    activeTeam: state.team.activeTeam,
    selectedTeamId: state.team.selectedTeamID,
    projects: state.team.projects,
    tasks: state.team.tasks,
    activeUserId: state.team.activeUserID,
    all: state.team.all,
    loading: false,
    selectedProject: state.team.selectedProject,
    active: state.team.active,
    membersData: state.team.membersData,
  }));

  const activeTeamId =
    teams.active?.activeTeamid ?? teams?.selectedTeamId ?? null;
  const { memberDetails } = useTeamMemberDetailsForSelect(activeTeamId);

  const members = useMemo(() => {
    if (!memberDetails || typeof memberDetails !== 'object') return [];
    return Object.entries(memberDetails)
      .map(([uid, m]) => ({
        userUID: uid,
        userName: m?.userName || m?.userEmailid || uid,
      }))
      .filter((m) => m.userUID)
      .sort((a, b) => (a.userName || '').localeCompare(b.userName || ''));
  }, [memberDetails]);

  const [selectedDate, setSelectedDate] = useState(new Date());

  const [formValues, setFormValues] = useState({
    title: null,
    description: null,
    assignee: null,
    status: null,
    priority: null,
    date: { value: new Date() },
  });
  const teamData = [];
  if (teams.projects.length > 0) {
    teams.projects.map((item) => {
      if (!item.data.deleted) {
        const obj = {
          name: item.data.project_name,
          id: item.id,
        };
        teamData.push(obj);
      }
    });
  }

  const newTeamData = teamData?.map((item) => ({
    value: item?.id,
    label: item?.name,
  }));
  const options = useMemo(
    () =>
      (members || []).map((member) => ({
        value: member.userUID,
        label: member.userName,
      })),
    [members]
  );
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [successData, setSuccessData] = React.useState(false);
  const [deleteData, setDeleteData] = React.useState(false);
  const [errorData, setErrorData] = React.useState(false);

  const [task, setTask] = React.useState([]);
  const [deleteLoading, setDeleteLoading] = React.useState(false);

  const pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  };

  const handleSubmit = async () => {
    if (
      !formValues.title?.value ||
      !formValues.description?.value ||
      !formValues.status?.value ||
      !formValues.priority?.value ||
      !formValues.assignee?.value
    ) {
      const requiredField = [
        'title',
        'description',
        'assignee',
        'status',
        'priority',
      ];
      for (let i = 0; i < requiredField.length; i++) {
        let field = requiredField[i];
        if (!formValues[field]?.value) {
          field = field === 'description' ? ' Summary' : startCase(field);
          addNotification({
            message: `${field} is required`,
            level: notificationStates.error,
          });
          return false;
        }
      }
    }
    setSubmitLoading(true);

    if (taskId && projectId) {
      let dateId = '';
      if (
        formValues.date?.value &&
        typeof formValues.date?.value === 'string'
      ) {
        dateId = formValues?.date?.value;
      } else if (typeof formValues.date?.value === 'object') {
        var month = pad2(formValues.date?.value?.getMonth() + 1);
        var day = pad2(formValues.date?.value?.getDate());
        var year = formValues.date?.value?.getFullYear();
        dateId = day + '/' + month + '/' + year;
      }
      await database
        .collection('taskDatabase')
        .doc(taskId)
        .update({
          Description: formValues.description?.value,
          Assignee: formValues.assignee?.value,
          Priority: formValues.priority?.value,
          Status: formValues.status?.value,
          Title: formValues.title?.value,
          ETA: dateId,
        })
        .then((data) => {
          setSuccessData(true);
          setSubmitLoading(false);
          addNotification({
            message: 'Task updated successfully',
            level: notificationStates.success,
          });
        })
        .catch((error) => {
          setSubmitLoading(false);
          addNotification({
            message: 'Task update failed',
            level: notificationStates.error,
          });
          throw error;
        });
    } else {
      var month = pad2(formValues.date?.value?.getMonth() + 1);
      var day = pad2(formValues.date?.value?.getDate());
      var year = formValues.date?.value?.getFullYear();
      let dateId = day + '/' + month + '/' + year;
      let taskId = '';

      database
        .runTransaction(async (transaction) => {
          const cityRef = database
            .collection('companyDatabase')
            .doc(activeCompany.companyId)
            .collection('projects')
            .doc(formValues.project?.value);
          const doc = await transaction.get(cityRef);

          const project = doc.data();
          const newTaskSplitd = project.project_name.split(' ');
          const firstLater =
            newTaskSplitd.length === 1
              ? `${newTaskSplitd[0][0]}${newTaskSplitd[0][1]}`
              : `${newTaskSplitd[0][0]}${newTaskSplitd[1][0]}`;
          const noOfTask = project?.taskList?.length || 0;
          taskId = `${firstLater.toUpperCase()}-${noOfTask + 1}`;
          const taskRef = database.collection('taskDatabase').doc(taskId);
          const arr = [];
          arr.push(taskId);
          if (project.taskList) {
            project.taskList.map((item) => arr.push(item));
            const newA = project.taskList.filter(
              (item) =>
                item.toLowerCase() === formValues.title?.value.toLowerCase()
            );
            if (newA.length === 0) {
              const cityRef = database
                .collection('companyDatabase')
                .doc(activeCompany.companyId)
                .collection('projects')
                .doc(formValues.project?.value);
              await transaction.update(cityRef, { taskList: arr });
            }
          } else {
            const cityRef = database
              .collection('companyDatabase')
              .doc(activeCompany.companyId)
              .collection('projects')
              .doc(formValues.project?.value);
            await transaction.update(cityRef, { taskList: [taskId] });
          }
          transaction.set(taskRef, {
            Title: formValues.title?.value,
            Description: formValues.description?.value,
            Priority: formValues.priority?.value,
            Assignee: formValues.assignee?.value,
            Status: formValues.status?.value,
            ProjectID: formValues.project?.value,
            ETA: dateId,
          });
        })
        .then(async (data) => {
          setFormValues({
            team: '',
            title: '',
            description: '',
            assignee: '',
            status: '',
            priority: '',
            date: new Date(),
          });
          setSuccessData(true);
          setSubmitLoading(false);
          addNotification({
            message: 'Task submitted successfully',
            level: notificationStates.success,
          });
          const pName = formValues.project?.label.split(' ').join('-');
          history.push(`/${pName}/${taskId}`);
        })
        .catch((error) => {
          addNotification({
            message: 'Task submission failed',
            level: notificationStates.error,
          });
        });
    }
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    const tb = database.collection('taskDatabase').doc(taskId);
    const cb = database
      .collection('companyDatabase')
      .doc(user?.activeCompany?.companyId)
      .collection('projects')
      .doc(projectId);
    return database
      .runTransaction(async (transaction) => {
        await transaction.update(tb, {
          Description: formValues.description?.value,
          Assignee: formValues.assignee?.value,
          Priority: formValues.priority?.value,
          Status: formValues.status?.value,
          Title: formValues.title?.value,
          Deleted: true,
        });
        await transaction.update(cb, {
          taskList: firebase.firestore.FieldValue.arrayRemove(taskId),
        });
      })

      .then((data) => {
        addNotification({
          message: 'Task deleted successfully',
          level: notificationStates.success,
        });
        setDeleteData(true);
        setDeleteLoading(false);
        setTimeout(() => {
          window.location = '/manage-tasks';
        }, 400);
      })
      .catch((error) => {
        setDeleteLoading(false);
        addNotification({
          message: 'Task deletion failed',
          level: notificationStates.error,
        });
        throw error;
      });
  };

  const callTaskList = async (pID) => {
    const taskData = await database
      .collection('taskDatabase')
      .where('ProjectID', '==', pID)
      .get();
    let lists = taskData?.docs.map((res) => res.data());
    let listId = taskData?.docs?.map((r) => r?.id);
    let listsWithId = [];
    for (let i = 0; i < lists.length; i++) {
      listsWithId.push({ ...lists[i], id: listId[i] });
    }
    const taskItem = listsWithId.filter((item) => item.id === taskId);

    if (taskItem) {
      var datearray = taskItem[0]?.ETA.split('/');
      var newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
      setSelectedDate(new Date(newdate));
      setFormValues({
        title: { value: taskItem[0]?.Title },
        description: { value: taskItem[0]?.Description },
        status: { value: taskItem[0]?.Status },
        priority: { value: taskItem[0]?.Priority },
        date: { value: taskItem[0]?.ETA },
      });
      setTask(taskItem);
    }
  };

  // const stripHtmlTags = (html) => {
  //   const tempElement = document.createElement("div");
  //   tempElement.innerHTML = html;
  //   return tempElement.textContent || tempElement.innerText || "";
  // };

  React.useEffect(() => {
    setTimeout(() => {
      setSuccessData(false);
      setErrorData(false);
      setDeleteData(false);
    }, 1500);
  }, [successData, errorData, deleteData]);

  const dispatchRef = useRef();

  useEffect(() => {
    dispatchRef.current = dispatch;
  }, [dispatch]);

  const FileUploadPlugin = useCallback(
    function (editor) {
      if (!taskId) {
        return FirebaseImageUploadPlugin(
          editor,
          formValues.title?.value,
          dispatchRef
        );
      }
      return FirebaseImageUploadPlugin(editor, taskId, dispatchRef);
    },
    [taskId, formValues, dispatchRef]
  );

  const actionName = taskId ? 'Update' : 'Create task';

  return (
    <>
      <div className={styles.taskPage}>
        <div className={styles.taskContainer}>
          <div className={styles.taskBox}>
            <div className="title">
              <p className="mb-0">Project name: {pName}</p>
            </div>
            <Input
              label="Title"
              placeholder="Task Title"
              value={formValues.title?.value}
              onChange={(e) => {
                setFormValues({
                  ...formValues,
                  title: { value: e.target.value },
                });
              }}
            />
            <div className={styles.descriptionEditor}>
              <label htmlFor="summaryField">Summary</label>
              <CKEditor
                className="ckEditor"
                editor={ClassicEditor}
                data={formValues.description?.value}
                config={{
                  extraPlugins: [FileUploadPlugin],
                }}
                onChange={(_, editor) => {
                  const value = editor.getData();
                  setFormValues({ ...formValues, description: { value } });
                }}
              />
            </div>
          </div>
          <div className={styles.addTaskFormDetails}>
            <Text
              variant={textVariantsEnum.Header}
              fontWeight={fontWeightEnum.Bold}
            >
              Details
            </Text>
            <div className={styles.addTaskFormDetailsContent}>
              <Dropdown
                options={options}
                selectStyles={borderedSelectStyles}
                defaultValue={formValues.assignee?.value || null}
                placeholder="Select assignee"
                onChange={(option) =>
                  setFormValues({ ...formValues, assignee: option })
                }
                label="Assignee"
              />
              <Dropdown
                options={statusOptions}
                selectStyles={borderedSelectStyles}
                placeholder="Select Status"
                onChange={(option) =>
                  setFormValues({ ...formValues, status: option })
                }
                label="Status"
              />
              <Dropdown
                options={priorityOptions}
                selectStyles={borderedSelectStyles}
                placeholder="Select Priority"
                onChange={(option) =>
                  setFormValues({ ...formValues, priority: option })
                }
                label="Priority"
              />
              <div className={styles.datePicker}>
                <Text
                  variant={textVariantsEnum.Text_13}
                  fontWeight={fontWeightEnum.Normal}
                >
                  ETA
                </Text>
                <DatePicker
                  className={styles.datePickerInput}
                  selected={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    setFormValues({
                      ...formValues,
                      date: { value: date },
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <Button
            color="primary"
            className="updateTaskButton"
            onClick={handleSubmit}
            disabled={imageUpload.imageUpload || !options.length > 0}
          >
            {submitLoading ? (
              <span>
                <Spinner size="sm" /> {actionName}
              </span>
            ) : (
              actionName
            )}
          </Button>
          {taskId && (
            <Button
              color="danger"
              onClick={handleDelete}
              disabled={!options.length > 0}
            >
              {deleteLoading ? (
                <span>
                  <Spinner size="sm" /> Delete
                </span>
              ) : (
                'Delete'
              )}
            </Button>
          )}
          {taskId && (
            <TaskHistoryButton
              taskId={taskId}
              className="secondary"
              style={{ marginLeft: '10px' }}
            >
              <span className="history-button-icon">📋</span>
              View History
            </TaskHistoryButton>
          )}
          {options?.length > 1 && taskId && (
            <div className="comments comment-section mt-4">
              <h3>Comments</h3>
              <div className="comment-list">
                {comments.length > 0 &&
                  Array.isArray(comments) &&
                  comments
                    .sort((a, b) => parseInt(b.id) - parseInt(a.id))
                    .map((comment, index) => {
                      const commenter =
                        members &&
                        members.find(
                          (member) => member.userUID === comment.userId
                        );
                      const userName = commenter
                        ? commenter.userName
                        : 'Unknown User';
                      const isEditing = editingCommentId === comment.id;
                      const hasImage = /<img[^>]+src="([^">]+)"/.test(
                        comment.comment
                      );

                      return (
                        <div key={index} className="comment comment-item">
                          <div className="comment-header">
                            <p className="username">{userName}</p>
                          </div>
                          <div className="comment-body">
                            {isEditing ? (
                              <CKEditor
                                className="ckEditor"
                                editor={ClassicEditor}
                                data={editedComment}
                                config={{
                                  extraPlugins: [FileUploadPlugin],
                                }}
                                onChange={(_, editor) => {
                                  const value = editor.getData();
                                  setEditedComment(value);
                                }}
                              />
                            ) : (
                              // strippedComment
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: comment.comment,
                                }}
                                className={hasImage ? 'comment-image' : ''}
                              />
                            )}
                          </div>
                          {/* Edit and delete buttons */}
                          <div className="save-edit-btn">
                            {isEditing ? (
                              <div className="comment-buttons">
                                <span
                                  disabled={
                                    imageUpload.imageUpload ||
                                    !options.length > 0
                                  }
                                  className="edit-comment"
                                  onClick={() =>
                                    handleUpdateComment(comment.id)
                                  }
                                >
                                  Save
                                </span>
                                <span
                                  className="delete-comment"
                                  onClick={() => handleCancelEdit()}
                                >
                                  Cancel
                                </span>
                              </div>
                            ) : (
                              <div className="comment-buttons">
                                <span
                                  className="edit-comment"
                                  onClick={() =>
                                    handleEditComment(
                                      comment.id,
                                      comment.comment
                                    )
                                  }
                                >
                                  Edit
                                </span>
                                <span
                                  className="delete-comment"
                                  onClick={() =>
                                    handleDeleteComment(comment.id)
                                  }
                                >
                                  Delete
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
              </div>

              {!showCommentBox && (
                <Button
                  text="Comment"
                  variant={buttonVariants.primary}
                  onClick={() => setShowCommentBox(true)}
                  disabled={editingCommentId !== null}
                />
              )}

              {showCommentBox && (
                <>
                  <div className="commentBox mb-4">
                    <div className="">
                      <CKEditor
                        className="ckEditor"
                        editor={ClassicEditor}
                        config={{
                          extraPlugins: [FileUploadPlugin],
                        }}
                        value={newComment}
                        onChange={(_, editor) => {
                          const value = editor.getData();
                          setNewComment(value);
                        }}
                        placeholder="Add a comment..."
                      />
                    </div>
                  </div>
                  <Button
                    text="Submit"
                    variant={buttonVariants.primary}
                    onClick={handleAddComment}
                    disabled={
                      imageUpload.imageUpload ||
                      !options.length > 0 ||
                      newComment.trim() === ''
                    }
                  />
                  <Button
                    text="Cancel"
                    variant={buttonVariants.secondary}
                    onClick={() => setShowCommentBox(false)}
                  />
                  <Button
                    text="Cancel"
                    variant={buttonVariants.secondary}
                    onClick={() => setShowCommentBox(false)}
                  />
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddUpdateTaskPage;
